import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';

/* This component sets up and removes listener events
so the wrapped component can be closed by outside clicks */

class OutsideClickListener extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        onOutsideClick: PropTypes.func,
        shouldListen: PropTypes.bool
    };

    component = React.createRef();

    componentDidUpdate(prevProps) {
        const didOpen = !prevProps.shouldListen && this.props.shouldListen;
        const didClose = prevProps.shouldListen && !this.props.shouldListen;
        if (didOpen) this.addMouseDownListener();
        if (didClose) this.removeMouseDownListener();
    }

    componentWillUnmount() {
        this.removeMouseDownListener();
    }

    addMouseDownListener = () => {
        root.addEventListener('mousedown', this.handleClick, false);
        // TODO: quick fix DevPortal mobile
        root.addEventListener('touchstart', this.handleClick, false);
    };

    removeMouseDownListener = () => {
        root.removeEventListener('mousedown', this.handleClick, false);
        // TODO: quick fix DevPortal mobile
        root.removeEventListener('touchstart', this.handleClick, false);
    };

    handleClick = event => {
        const {onOutsideClick} = this.props;
        if (this.component.current && !this.component.current.contains(event.target)) {
            onOutsideClick();
        }
    };

    render() {
        const {children, className} = this.props;

        return (
            <div className={className} ref={this.component}>
                {children}
            </div>
        );
    }
}

export default OutsideClickListener;
